import { BACKEND_URL } from 'env';

/** WebSocket URL for Action Cable (same host as API; browser sends HttpOnly `auth_token` cookie). */
export function getActionCableUrl(): string | null {
  const base = (BACKEND_URL ?? '').replace(/\/api\/v1\/?$/, '');
  if (!base) return null;
  if (base.startsWith('https://')) {
    return `${base.replace(/^https/, 'wss')}/cable`;
  }
  return `${base.replace(/^http/, 'ws')}/cable`;
}
